module.exports = __webpack_public_path__ + "img/step12_a_basket_basic_clip_tubes.09d8828b.png";